import { LightningElement, api } from "lwc";
import { createTrack } from "common/track";

class headerProfile extends LightningElement {
  @api user = undefined;
  @api userDescription = "";
  track = createTrack(this);

  get menuOptions() {
    return this.user.navItems.map((item) => ({
      ...item.link,
      label: item.label,
    }));
  }

  onSummaryClick() {
    this.track("menu_opened", undefined);
  }

  onUserMenuTrack(e) {
    this.track(e.detail.eventName, e.detail.payload);
  }
}

export default headerProfile;
